export default __webpack_public_path__ + "static/media/answer.898f4e75.gif";